/**
 * Base origin of the Runhuman web app — required at build time via
 * `VITE_RUNHUMAN_WEB_URL`. Production builds set it to `https://runhuman.com`,
 * dev builds set it via `.env.local`.
 *
 * Module-load fail-fast: an empty value throws here so a misconfigured build
 * is caught immediately instead of silently shipping broken deep links to
 * `runhuman.com/tester/test/...`, `runhuman.com/tester/schedule`,
 * `/dashboard/settings/account`, etc.
 *
 * Single source for every Activity surface that hands off to the web app:
 * the unlinked-user CTA, the post-claim browser pop, the in-progress resume
 * button, the late-submission rejoin, and the schedule-tab "Manage schedule"
 * link (#3923).
 */
const raw = import.meta.env.VITE_RUNHUMAN_WEB_URL;
if (!raw) {
  throw new Error(
    'VITE_RUNHUMAN_WEB_URL is not set. The Activity needs the Runhuman web URL at build time ' +
    'so deep links to /tester/test/:jobId, /tester/schedule, /dashboard/settings/account, etc. ' +
    'resolve correctly. Add it to .env.local for dev or to the deploy environment for production.',
  );
}

export const WEB_BASE_URL: string = raw;
